function AttributePost({search, currentPosts, checkedControl, handleChecked, setEditData}: any) {
  return search(currentPosts)?.map((item: any, index: any) => (
    <tr key={index}>
      <td>
        <input
          className='form-check-input'
          type='checkbox'
          value={item.id}
          checked={checkedControl(String(item.id))}
          onChange={(e) => (handleChecked(e), setEditData(item))}
        />
      </td>
      <td>{item.id}</td>
      <td>{item.description}</td>
      <td>{item.value}</td>

      <td>{item.key}</td>
      <td>{item.maxValue}</td>
    </tr>
  ))
}

export default AttributePost
